export default function clickableModules() {

  var allClickableModuleButtons = $('.js-clickable-module-button');

  // For each clickable module button
  $(allClickableModuleButtons).each(function() {
    var url     = $(this).attr('href');
    var parent  = $(this).closest('.js-clickable-module-parent');
    $(parent).addClass('is-clickable'); // This is a hook for the CSS.
    $(parent).on('click', function() {
      window.location.href = url;
    });
  });

}
